import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const SetupScore = () => {
  const [configGame, setConfigGame] = useState();
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

  // MAX_SCORE
  const [vip0_5, setVip0_5] = useState(0);
  const [vip6_11, setVip6_11] = useState(0);
  const [vip12_15, setVip12_15] = useState(0);
  const [vip16_20, setVip16_20] = useState(0);

  // GHOST_RATE (% hiển thị)  <-- HIỂN THỊ LÀ %
  const [rwd0_5, setRwd0_5] = useState(0);
  const [rwd6_11, setRwd6_11] = useState(0);
  const [rwd12_15, setRwd12_15] = useState(0);
  const [rwd16_20, setRwd16_20] = useState(0);

  const [multiple, setMultiple] = useState(0);

  // Ranking rewards
  const [top1, setTop1] = useState();
  const [top2, setTop2] = useState();
  const [top3, setTop3] = useState();
  const [top4, setTop4] = useState();
  const [top5, setTop5] = useState();
  const [top6, setTop6] = useState();
  const [top7, setTop7] = useState();
  const [top8, setTop8] = useState();
  const [top9, setTop9] = useState();
  const [top10, setTop10] = useState();

  // Removed Jackpot inputs section

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getDataConfig();
  }, []);

  // Validate
  const validNonNegativeNumber = (v) => {
    if (v === undefined || v === null || v === "") return false;
    const n = Number(v);
    return Number.isFinite(n) && n >= 0;
  };

  const validPositiveNumber = (v) => {
    if (v === undefined || v === null || v === "") return false;
    const n = Number(v);
    return Number.isFinite(n) && n > 0;
  };

  const validPercent = (v) => {
    if (v === undefined || v === null || v === "") return false;
    const n = Number(v);
    return Number.isFinite(n) && n >= 0 && n <= 100;
  };

  // Load config
  const getDataConfig = async () => {
    try {
      const res = await API.get(`${CONFIG}`);
      const data = res.data.data;

      setConfigGame({
        vip0_5: data?.vipLevels?.["VIP_0_5"] ?? {},
        vip6_11: data?.vipLevels?.["VIP_6_11"] ?? {},
        vip12_15: data?.vipLevels?.["VIP_12_15"] ?? {},
        vip16_20: data?.vipLevels?.["VIP_16_20"] ?? {},
        multiple: data?.multiple,
        top1: data?.eventRewards?.["TOP1"],
        top2: data?.eventRewards?.["TOP2"],
        top3: data?.eventRewards?.["TOP3"],
        top4: data?.eventRewards?.["TOP4"],
        top5: data?.eventRewards?.["TOP5"],
        top6: data?.eventRewards?.["TOP6"],
        top7: data?.eventRewards?.["TOP7"],
        top8: data?.eventRewards?.["TOP8"],
        top9: data?.eventRewards?.["TOP9"],
        top10: data?.eventRewards?.["TOP10"],
        pointsJackpot: data?.pointsJackpot ?? {},
      });

      // MULTIPLE (vòng cược trước khi rút)
      setMultiple(Number(data?.multiple ?? 0));

      // MAX_SCORE
      setVip0_5(data?.vipLevels?.["VIP_0_5"]?.MAX_SCORE ?? 0);
      setVip6_11(data?.vipLevels?.["VIP_6_11"]?.MAX_SCORE ?? 0);
      setVip12_15(data?.vipLevels?.["VIP_12_15"]?.MAX_SCORE ?? 0);
      setVip16_20(data?.vipLevels?.["VIP_16_20"]?.MAX_SCORE ?? 0);

      // GHOST_RATE từ DB là dạng thập phân (0..1) -> hiển thị %
      setRwd0_5(Number((data?.vipLevels?.["VIP_0_5"]?.GHOST_RATE ?? 0) * 100));
      setRwd6_11(Number((data?.vipLevels?.["VIP_6_11"]?.GHOST_RATE ?? 0) * 100));
      setRwd12_15(Number((data?.vipLevels?.["VIP_12_15"]?.GHOST_RATE ?? 0) * 100));
      setRwd16_20(Number((data?.vipLevels?.["VIP_16_20"]?.GHOST_RATE ?? 0) * 100));

      // Ranking rewards
      setTop1(data?.eventRewards?.["TOP1"]);
      setTop2(data?.eventRewards?.["TOP2"]);
      setTop3(data?.eventRewards?.["TOP3"]);
      setTop4(data?.eventRewards?.["TOP4"]);
      setTop5(data?.eventRewards?.["TOP5"]);
      setTop6(data?.eventRewards?.["TOP6"]);
      setTop7(data?.eventRewards?.["TOP7"]);
      setTop8(data?.eventRewards?.["TOP8"]);
      setTop9(data?.eventRewards?.["TOP9"]);
      setTop10(data?.eventRewards?.["TOP10"]);
    } catch (err) {
      console.log(err);
    }
  };

  // Common handlers (ranking)
  const handleChangeInput = (e, key) => {
    switch (key) {
      case 5: setTop1(e); return;
      case 6: setTop2(e); return;
      case 7: setTop3(e); return;
      case 8: setTop4(e); return;
      case 9: setTop5(e); return;
      case 10: setTop6(e); return;
      case 11: setTop7(e); return;
      case 12: setTop8(e); return;
      case 13: setTop9(e); return;
      case 14: setTop10(e); return;
      default: return;
    }
  };

  const handleUpdateConfig = async () => {
    try {
      setIsShowModalConfirm(false);

      // Validate MAX_SCORE (>=0) + GHOST_RATE (0..100) hiển thị
      if (
        !validNonNegativeNumber(vip0_5) ||
        !validNonNegativeNumber(vip6_11) ||
        !validNonNegativeNumber(vip12_15) ||
        !validNonNegativeNumber(vip16_20) ||
        !validPercent(rwd0_5) ||
        !validPercent(rwd6_11) ||
        !validPercent(rwd12_15) ||
        !validPercent(rwd16_20)
      ) {
        showError("Vui lòng nhập hợp lệ (MAX_SCORE ≥ 0, Tỉ lệ trúng 0–100%).");
        return;
      }

      // Validate ranking ( > 0 )
      if (
        !validPositiveNumber(top1) || !validPositiveNumber(top2) || !validPositiveNumber(top3) ||
        !validPositiveNumber(top4) || !validPositiveNumber(top5) || !validPositiveNumber(top6) ||
        !validPositiveNumber(top7) || !validPositiveNumber(top8) || !validPositiveNumber(top9) ||
        !validPositiveNumber(top10)
      ) {
        showError("Bảng xếp hạng phải là số dương (>0).");
        return;
      }

      // Validate multiple (>0)
      if (!validPositiveNumber(multiple)) {
        showError("Vòng cược trước khi rút phải là số dương (>0).");
        return;
      }

      setIsShowModalSuccess(true);

      // Khi lưu: chia 100 để đưa về dạng thập phân (0..1)
      const body = {
        config: {
          vipLevels: {
            VIP_0_5: {
              ...(configGame?.vip0_5 ?? {}),
              MAX_SCORE: Number(vip0_5 ?? 0),
              GHOST_RATE: Number((rwd0_5 ?? 0)) / 100,
            },
            VIP_6_11: {
              ...(configGame?.vip6_11 ?? {}),
              MAX_SCORE: Number(vip6_11 ?? 0),
              GHOST_RATE: Number((rwd6_11 ?? 0)) / 100,
            },
            VIP_12_15: {
              ...(configGame?.vip12_15 ?? {}),
              MAX_SCORE: Number(vip12_15 ?? 0),
              GHOST_RATE: Number((rwd12_15 ?? 0)) / 100,
            },
            VIP_16_20: {
              ...(configGame?.vip16_20 ?? {}),
              MAX_SCORE: Number(vip16_20 ?? 0),
              GHOST_RATE: Number((rwd16_20 ?? 0)) / 100,
            },
          },
          eventRewards: {
            TOP1: Number(top1),
            TOP2: Number(top2),
            TOP3: Number(top3),
            TOP4: Number(top4),
            TOP5: Number(top5),
            TOP6: Number(top6),
            TOP7: Number(top7),
            TOP8: Number(top8),
            TOP9: Number(top9),
            TOP10: Number(top10),
          },
          multiple: Number(multiple ?? 0),
        },
      };

      await API.patch(`${UPDATE_CONFIG}`, body);
    } catch (err) {
      console.log(err);
    }
  };

  const showError = (errorMessage) => {
    messageApi.open({
      type: "error",
      content: errorMessage,
    });
  };

  const handleShowModal = () => {
    setIsShowModalConfirm(true);
  };

  // Reusable row
  const renderInputNumer = (
    key,
    defaultValue,
    changeInput,
    max,
    label,
    isText = false
  ) => {
    return (
      <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
        <div className="flex w-[20%] justify-end mr-10">{label}:</div>
        <div className="w-[60%]">
          {
            <InputNumber
              key={key}
              style={{ width: "100%" }}
              value={defaultValue}
              onChange={changeInput}
              max={max}
              min={0}
            />
          }
        </div>
      </div>
    );
  };

  return (
    <div className="col-12" style={{ background: "#f7f9fa", minHeight: "100vh", padding: 24 }}>
      {contextHolder}
      <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 16 }}>Cài đặt điểm nhận</div>

      <div style={{ background: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 2px 8px #eee", marginBottom: 32 }}>
        {/* VIP */}
        <div style={{ fontWeight: 500, fontSize: 16, marginBottom: 12 }}>Cấp VIP và tỉ lệ trả thưởng</div>
        <div style={{ display: "flex", gap: 24, marginBottom: 24 }}>
          <div style={{ width: "100%" }}>
            <div style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", gap: "12px", marginBottom: 8 }}>
              <div></div>
              <div style={{ textAlign: "center", fontWeight: 400 }}>Điểm nhận cao nhất trong 1 lượt</div>
              <div style={{ textAlign: "center", fontWeight: 400 }}>Tỉ lệ % xuất hiện vật phẩm</div>
            </div>

            {/* Rows */}
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {/* VIP 0-5 */}
              <div style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", gap: "12px", alignItems: "center" }}>
                <span style={{ textAlign: "right" }}>VIP 0 - 5:</span>
                <InputNumber style={{ width: "100%" }} value={vip0_5} onChange={(v) => setVip0_5(Number(v ?? 0))} max={500} min={0} />
                <InputNumber
                  style={{ width: "100%" }}
                  value={rwd0_5}
                  onChange={(v) => setRwd0_5(Number(v ?? 0))}
                  max={100}
                  min={0}
                  step={0.01}
                  precision={2}
                />
              </div>

              {/* VIP 6-11 */}
              <div style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", gap: "12px", alignItems: "center" }}>
                <span style={{ textAlign: "right" }}>VIP 6 - 11:</span>
                <InputNumber style={{ width: "100%" }} value={vip6_11} onChange={(v) => setVip6_11(Number(v ?? 0))} max={500} min={0} />
                <InputNumber
                  style={{ width: "100%" }}
                  value={rwd6_11}
                  onChange={(v) => setRwd6_11(Number(v ?? 0))}
                  max={100}
                  min={0}
                  step={0.01}
                  precision={2}
                />
              </div>

              {/* VIP 12-15 */}
              <div style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", gap: "12px", alignItems: "center" }}>
                <span style={{ textAlign: "right" }}>VIP 12 - 15:</span>
                <InputNumber style={{ width: "100%" }} value={vip12_15} onChange={(v) => setVip12_15(Number(v ?? 0))} max={500} min={0} />
                <InputNumber
                  style={{ width: "100%" }}
                  value={rwd12_15}
                  onChange={(v) => setRwd12_15(Number(v ?? 0))}
                  max={100}
                  min={0}
                  step={0.01}
                  precision={2}
                />
              </div>

              {/* VIP 16-20 */}
              <div style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", gap: "12px", alignItems: "center" }}>
                <span style={{ textAlign: "right" }}>VIP 16 - 20:</span>
                <InputNumber style={{ width: "100%" }} value={vip16_20} onChange={(v) => setVip16_20(Number(v ?? 0))} max={500} min={0} />
                <InputNumber
                  style={{ width: "100%" }}
                  value={rwd16_20}
                  onChange={(v) => setRwd16_20(Number(v ?? 0))}
                  max={100}
                  min={0}
                  step={0.01}
                  precision={2}
                />
              </div>
            </div>
            {/* Vòng cược trước khi rút */}
            <div style={{ display: "grid", gridTemplateColumns: "160px 1fr", gap: "12px", alignItems: "center", marginTop: 16 }}>
              <span style={{ textAlign: "right" }}>Vòng cược trước khi rút:</span>
              <InputNumber
                style={{ width: "100%" }}
                value={multiple}
                onChange={(v) => setMultiple(Number(v ?? 0))}
                min={1}
                max={999}
              />
            </div>
          </div>
        </div>

        {/* Ranking */}
        <div style={{ fontWeight: 500, fontSize: 16, marginBottom: 12 }}>Bảng xếp hạng</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: 24 }}>
          {renderInputNumer("top1", top1, (e) => handleChangeInput(e, 5), 999, "Top 1")}
          {renderInputNumer("top2", top2, (e) => handleChangeInput(e, 6), 999, "Top 2")}
          {renderInputNumer("top3", top3, (e) => handleChangeInput(e, 7), 999, "Top 3")}
          {renderInputNumer("top4", top4, (e) => handleChangeInput(e, 8), 999, "Top 4")}
          {renderInputNumer("top5", top5, (e) => handleChangeInput(e, 9), 999, "Top 5")}
          {renderInputNumer("top6", top6, (e) => handleChangeInput(e, 10), 999, "Top 6")}
          {renderInputNumer("top7", top7, (e) => handleChangeInput(e, 11), 999, "Top 7")}
          {renderInputNumer("top8", top8, (e) => handleChangeInput(e, 12), 999, "Top 8")}
          {renderInputNumer("top9", top9, (e) => handleChangeInput(e, 13), 999, "Top 9")}
          {renderInputNumer("top10", top10, (e) => handleChangeInput(e, 14), 999, "Top 10")}
        </div>

        {/* Jackpot section removed */}

        <div style={{ textAlign: "center", marginTop: 24 }}>
          <Button type="primary" size="large" style={{ minWidth: 120 }} onClick={handleShowModal}>
            Cập nhật
          </Button>
        </div>
      </div>

      {/* Confirm */}
      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0062}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={handleUpdateConfig}
          close={() => setIsShowModalConfirm(false)}
        />
      )}

      {/* Success */}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0063}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => setIsShowModalSuccess(false)}
          close={() => setIsShowModalSuccess(false)}
        />
      )}
    </div>
  );
};

export default SetupScore;
